import { FlowSwitchBlockConfigSchema } from 'flow-schema';
import { z } from 'zod';

import { BaseFlowBlockSchema, BlockType } from '../base/baseSchema.js';

export const SwitchBlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(BlockType.Switch),
  config: FlowSwitchBlockConfigSchema,
});
export type SwitchBlock = z.infer<typeof SwitchBlockSchema>;
